import { List } from "@mui/material";
import styled from "styled-components";

const StyledList = styled(List)`
  padding: 5px;
  margin-bottom: 10px;
  width: 180px;
  a {
    text-decoration: none;
    color: #fff;
  }
`;

export { StyledList };
